/**
 * Shared franchise-aware column definitions for RecordList/DataGrid views.
 *
 * Usage:
 *   import { getLicenseeColumn } from '../components/franchiseColumns';
 *   const { isFranchise, licensees, currentLicensee } = React.useContext(ContextStore);
 *   columns={[
 *       ...getLicenseeColumn(isFranchise, licensees, currentLicensee),
 *       { field: 'name', ... },
 *   ]}
 *
 * Returns an empty array when not in franchise mode or when a specific
 * licensee is selected, so the spread is a no-op.
 */

export const buildLicenseeMap = (licensees) => {
    const map = {};
    (licensees || []).forEach((l) => {
        map[l.id] = l.name;
    });
    return map;
};

export const getLicenseeColumn = (isFranchise, licensees, currentLicensee, options = {}) => {
    if (!isFranchise || currentLicensee != null) return [];
    const dataField = options.field || 'tour_operator';
    return [{
        field: dataField,
        headerName: options.headerName || 'Licensee',
        flex: options.flex || 0.8,
        minWidth: options.minWidth || 100,
        sortable: false,
        type: 'singleSelect',
        valueOptions: (licensees || []).map((l) => ({ value: l.id, label: l.name })),
        valueGetter: (p) => {
            const toVal = p.row[dataField];
            if (toVal == null) return null;
            if (typeof toVal === 'object') return toVal.id;
            return toVal;
        },
        renderCell: (p) => {
            const toVal = p.row[dataField];
            if (toVal == null) return '';
            if (typeof toVal === 'object') return toVal.name || '';
            const lic = (licensees || []).find((l) => l.id === toVal);
            return lic?.name || '';
        },
    }];
};
